import { Box, IconButton, styled, Toolbar, useTheme } from "@mui/material";
import MuiAppBar, { AppBarProps as MuiAppBarProps } from "@mui/material/AppBar";
import TallyBrownLogo from "../../assets/Tally_Logotype_RGB_Brown.png";
import OpenDrawerIcon from "../icons/OpenDrawerIcon.tsx";
import SETTINGS from "../../lib/TallyLibrary/constants/configGeneral.json";

interface AppBarProps extends MuiAppBarProps {
  open?: boolean;
}

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})<AppBarProps>(({ theme }) => ({
  backgroundColor: "#e3e3dc",
  transition: theme.transitions.create(["margin", "width"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  variants: [
    {
      props: ({ open }) => open,
      style: {
        width: "100%",
        marginLeft: `${SETTINGS.drawerWidth}px`,
        transition: theme.transitions.create(["margin", "width"], {
          easing: theme.transitions.easing.easeOut,
          duration: theme.transitions.duration.enteringScreen,
        }),
      },
    },
  ],
}));

interface MobileAppBarProps {
  openDrawer: boolean;
  anonymousSession: boolean;
  isScreenBiggerThanOrEqualToLg: boolean;
  handleDrawerOpen: () => void;
}

const MobileAppBar: React.FC<MobileAppBarProps> = ({
  openDrawer,
  anonymousSession,
  isScreenBiggerThanOrEqualToLg,
  handleDrawerOpen,
}) => {
  const theme = useTheme();

  return (
    <AppBar
      position="fixed"
      elevation={0}
      open={openDrawer}
      sx={{ boxShadow: "none" }}
    >
      <Toolbar
        variant="dense"
        sx={[
          {
            display: "flex",
            flexDirection: "row",
            justifyContent: openDrawer ? "flex-end" : "space-between",
            alignItems: "center",
            minHeight: "56px",
            pl: { xs: "1.1rem", sm: "1.5rem", md: "2.5rem" },
            pr: { xs: "1.7rem", sm: "1.9rem", md: "3.3rem" },
            mt: "20px",
          },
        ]}
      >
        {!anonymousSession && !isScreenBiggerThanOrEqualToLg ? (
          <IconButton
            onClick={handleDrawerOpen}
            sx={[
              {
                display: openDrawer ? "none" : "inline-flex",
                alignItems: "center",
                justifyContent: "center",
              },
            ]}
          >
            <OpenDrawerIcon
              color={theme.palette.common.black}
              fontSize={theme.typography.h5.fontSize}
            />
          </IconButton>
        ) : (
          <Box />
        )}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%", // take full toolbar height
          }}
        >
          <Box
            component="img"
            src={TallyBrownLogo}
            alt="Tally logo"
            sx={{
              height: "32px",
              width: "auto",
            }}
          />
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default MobileAppBar;
